import type { LayerItemType } from "../../../models";

export function isPositionLayer(itemType: LayerItemType | undefined) {
	return itemType === "Representatives" || itemType === "Machines";
}

export function isRetailLayer(itemType: LayerItemType | undefined) {
	return itemType === "RetailLocations" || itemType === "Doors";
}

export function isOfficeLayer(itemType: LayerItemType | undefined) {
	return itemType === "Offices" || itemType === "ISOs";
}
